export default "/images/9d0d0a52839703be3297e9e08bc77c94.avif";